import { IBaseResponse, fetchWrapper, extractPaginationInfo } from './apiBase';
import { IResourceVersion, IRepositoryEntry, IRepository, ICommit, IPagination } from '@/types';
import { IRepositoryBranch } from '@/lib/repositoryBranchesApi';
import { BASE_API_URL } from '@/config/environment';

// https://staging.hub.oxen.ai/api/repos/ox/SQuAD-Context/tabular/main

export interface ITabularFileResponse extends IBaseResponse {
  entries: IRepositoryEntry[];
  pagination?: IPagination;
}

const responseHandler = (data: any): ITabularFileResponse => {
  const { entries, status, status_message, error } = data;
  const pagination = extractPaginationInfo(data);
  return {
    status,
    status_message,
    entries: entries || [],
    pagination,
    error: error || null,
  };
};

interface ITabularFileRequest {
  repository: IRepository;
  commitRef?: string;
  token?: string;
}

export const fetchTabularFilesForRepository = async ({
  repository,
  commitRef,
  token,
}: ITabularFileRequest): Promise<ITabularFileResponse> => {
  const commitOrBranchRef = commitRef || repository.default_branch;
  const targetUrl = `${BASE_API_URL}/repos/${repository.namespace}/${repository.name}/tabular/${commitOrBranchRef}`;

  const data = await fetchWrapper({
    resourceName: 'tabularFiles',
    targetUrl,
    authToken: token,
    resourceContext: { namespace: repository.namespace, repositoryName: repository.name, commitRef },
  });
  return responseHandler(data);
};

export interface IFileVersion {
  commit: ICommit;
  resource: IResourceVersion;
  schema_hash?: string;
}

export interface IRepositoryBranchVersionsResponse extends IBaseResponse {
  branch?: IRepositoryBranch;
  versions: IFileVersion[];
}

// https://staging.hub.oxen.ai/api/repos/ox/FacialEmotionRecognition/branches/main/versions/predictions/vit_fine_tune.csv
export const fetchVersionsForFile = async ({
  namespace,
  repositoryName,
  branchName = 'main',
  filePath,
  token,
}: {
  namespace: string;
  repositoryName: string;
  branchName: string;
  filePath: string;
  token?: string;
}): Promise<IRepositoryBranchVersionsResponse> => {
  const targetUrl = `${BASE_API_URL}/repos/${namespace}/${repositoryName}/branches/${branchName}/versions/${filePath}`;

  return await fetchWrapper({
    resourceName: 'fileVersions',
    targetUrl,
    authToken: token,
    resourceContext: { namespace, repositoryName, commitRef: branchName, filePath },
  });
};
